import type { User } from '@supabase/supabase-js';
import { useSession } from './useSession';

/**
 * Hook ligero: extrae `user` del singleton compartido de `useSession`.
 *
 * Antes hacía `sb.auth.getUser()` + suscripción propia a onAuthStateChange,
 * lo que causaba round-trip a Supabase Auth en cada mount + competencia
 * por el Web Lock con otras suscripciones. Ahora reusa el snapshot global
 * que ya mantiene useSession — sync, sin red, sin lock.
 */
export function useUser(): { user: User | null; loading: boolean } {
  const { user, loading } = useSession();
  return { user, loading };
}
